export default __webpack_public_path__ + "static/media/diagram-en-desktop.b2af7e15.jpg";